import React, { useMemo } from 'react';
import { UncontrolledTooltip } from 'reactstrap';
import { MonitoringAgentCard } from 'components/MonitoringAgentCard';
import { TooltipText } from '../styles';

export const AgentItem = ({ agent, layoutOption, borderRadius }) => {
  // Gera um id para usar no DOM de forma que o Tooltip possa funcionar
  const safeId = useMemo(
    () =>
      `agent-card-${
        agent.agentLogin?.replace(/[^a-zA-Z0-9]/g, '_') || 'unknown'
      }-${agent.queueName?.replace(/[^a-zA-Z0-9]/g, '_') || 'unknown'}`,
    [agent.agentLogin, agent.queueName]
  );

  return (
    <div id={safeId}>
      <MonitoringAgentCard agent={agent} borderRadius={borderRadius} />
      {layoutOption === 'one_card_per_agent' &&
        agent.queues &&
        agent.queues.length > 0 && (
          <UncontrolledTooltip
            placement="top"
            target={safeId}
            trigger="hover"
            delay={{ show: 100, hide: 0 }}
          >
            <TooltipText>
              <strong>Filas:</strong>
              <br />
              {agent.queues.map((queue) => queue.name).join(', ')}
            </TooltipText>
          </UncontrolledTooltip>
        )}
    </div>
  );
};
